// Function for placing commas in numbers
const getNumberWithSpaces = (num: number) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export default getNumberWithSpaces;
